import React, { useEffect, useState, useMemo } from "react"
import { EconomicsTemplate } from "components/templates/top/economics"
import { indicatorListApi } from "components/actions/indicatorList"
import { withRouter, WithRouterProps } from "react-router"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"
import { get } from "lodash"
import { Sort } from "utils/sort"

export const Economics: WithRouterProps<React.FC> = withRouter(
  ({ location }) => {
    const [indicationList, changeIndicationList] = useState([])
    const [transitionData, setTransitionData] = useState([])
    const loadResistId = useMemo(() => uuid(), [])
    const [refreshFlag, setRefreshFlag] = useState(false)
    const isPageLoading = useSelector(
      (state: { PageLoad: LoadStateType }) => state.PageLoad.load
    )

    const requestApi = async (
      apiParam?: string,
      displayPeriodNum?: number,
      selectMonthNum?: number,
      industryNum?: number
    ) => {
      store.dispatch(pageLoadRegist(loadResistId, true))
      await indicatorListApi({
        apiParam: apiParam || "Top.Indicator.Today",
        displayPeriodNum: displayPeriodNum || 0,
        selectMonthNum: selectMonthNum || 0,
        industryNum: industryNum || 0,
        changeIndicatorList: changeIndicationList,
      })
      if (location.state) {
        setTransitionData(location.state)
      }
      store.dispatch(pageLoadRegist(loadResistId, false))
    }

    useEffect(() => {
      requestApi()
    }, [])

    //ページ更新
    useEffect(() => {
      if (isPageLoading) {
        const displayPeriodNum = get(indicationList, "displayPeriodNum")
        const selectMonthNum = get(indicationList, "selectMonthNum")
        const industryNum = get(indicationList, "industryNum")
        const apiParam =
          displayPeriodNum === 4
            ? Sort.EconomicMonth[selectMonthNum].apiCall
            : displayPeriodNum === 5
            ? Sort.EconomicDateSortByIndustry[industryNum].apiCall
            : Sort.EconomicDate[displayPeriodNum].apiCall

        requestApi(apiParam, displayPeriodNum, selectMonthNum, industryNum)
      }
    }, [isPageLoading])

    useEffect(() => {
      if (refreshFlag) {
        const displayPeriodNum = get(indicationList, "displayPeriodNum")
        const selectMonthNum = get(indicationList, "selectMonthNum")
        const industryNum = get(indicationList, "industryNum")
        const apiParam =
          displayPeriodNum === 4
            ? Sort.EconomicMonth[selectMonthNum].apiCall
            : displayPeriodNum === 5
            ? Sort.EconomicDateSortByIndustry[industryNum].apiCall
            : Sort.EconomicDate[displayPeriodNum].apiCall

        requestApi(apiParam, displayPeriodNum, selectMonthNum, industryNum)
        setRefreshFlag(false)
      }
    }, [refreshFlag])

    return (
      <EconomicsTemplate
        indicationList={indicationList}
        changeIndicationList={changeIndicationList}
        transitionData={transitionData}
        setTransitionData={setTransitionData}
        setRefreshFlag={setRefreshFlag}
      />
    )
  }
)
